import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { coachPaths } from "../../../../routes/coach";
import { adminPaths } from "../../../../routes/admin";
import { useLocation, useNavigate } from "react-router-dom";
import ReserveYourSpot from "../../../Modals/common/reserve-your-spot";
import SavedAs from "../../../Modals/common/reserve-your-spot/SavedAs";
import {
  createNuterraData,
  updateNuterraData,
} from "../../../../redux/features/admin/actions/authAction";
import { localToUTCDateTimeParts, utcToLocalDateTimeParts } from "../../../../utils/pip";

const Wellness = ({
  contentEditable = false,
  data = {},
  openSignUp = () => { },
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [status, setSatus] = useState(data?.status || "Draft");
  const { pathname } = useLocation();
  const [isModal, setIsModal] = useState(false);
  const [isSavedAsModal, setIsSavedAsModal] = useState(false);
  const [headerFirstImage, setHeaderFirstImage] = useState(
    data?.section1?.header_first_image || ""
  );
  const [headerSecondImage, setHeaderSecondImage] = useState(
    data?.section1?.header_second_image || ""
  );
  const [cardImages, setCardImages] = useState([
    data?.section2?.cardimage_1 || null,
    data?.section2?.cardimage_2 || null,
    data?.section2?.cardimage_3 || null,
  ]);

  const handleReserveYourSpot = (e) => {
    e.preventDefault();
    if (pathname == coachPaths?.NuvioWellness) {
      setIsModal(true);
    }
  };

  const { date, time } = utcToLocalDateTimeParts(data?.section1?.date, data?.section1?.time);

  const [templateData, setTemplateData] = useState({
    section1: {
      heading: data?.section1?.heading || "NuTerra:",
      subHeading:
        data?.section1?.subHeading || "Where Wellness Meets Performance",
      body:
        data?.section1?.body ||
        "NuTerra is NUVIO’s holistic wellness journey designed to restore balance in fast-paced, high-pressure environments. It brings together nature-led experiences, mindfulness practices, and meaningful human connection, it supports sustainable well-being both personally and professionally. \n\n At the heart of NuTerra is a simple belief: growth starts with grounding. Through guided hikes, mindfulness, and shared experiences, participants reconnect with their rhythm, realign their energy, and build collective resilience.  It’s not about doing more — it’s about slowing down to thrive, sustainably.",
      date: date || "",
      time: time || "",
      location: data?.section1?.location || "Le Pouce Mountain, Mauritius",
      language: data?.section1?.language || "English/French",
      duration: data?.section1?.duration || "5 hours",
    },
    section2: {
      heading: data?.section2?.heading || "The NUVIO Wellness Journey",
      subHeading: data?.section2?.subHeading || "RECONNECT · ALIGN · THRIVE",
      cards: data?.section2?.cards || [
        {
          titleSmall: "Hiking Wellness",
          titleMain: "Reconnect",
          shortDesc: "Reconnection with self, nature and presence.",
          tagline: "Step out of the noise. Step into presence.",
          description:
            "Our guided wellness hikes are designed to help you step away from noise and pressure. Through mindful walking and natural rhythms, hiking becomes a space to reconnect with your body, your breath and your inner clarity.",
          benefits: [
            "Mental reset",
            "Emotional grounding",
            "Fresh perspective",
            "Calm, sustainable energy",
          ],

          image: "/assets/img/recoonect_img_1.png",
          bgColor: "hsl(43deg 100% 51% / 26%)",
        },
        {
          titleSmall: "Mindfulness",
          titleMain: "Align",
          shortDesc: "Alignment of mind, body, and intention.",
          tagline: "Calm the mind. Refocus the energy.",
          description:
            "Our mindfulness sessions help you slow down without stopping. Simple, accessible practices bring clarity, emotional balance, and intentional focus on and off the mat.",
          benefits: [
            "Emotional balance",
            "Sharper focus",
            "Reduced stress",
            "Clearer decision-making",
          ],

          image: "/assets/img/recoonect_img_2.png",
          bgColor: "hsl(32deg 100% 49% / 34%)",
        },
        {
          titleSmall: "Community Wellness",
          titleMain: "Thrive",
          shortDesc: "Sustainable growth through human connection",
          tagline: "Because well-being grows stronger together.",
          description:
            "Our community experiences are designed to create trust, belonging, and shared momentum. No performance. No pressure. Just meaningful connection that supports long-term growth.",
          benefits: [
            "Stronger human connections",
            "Psychological safety",
            "Collective resilience",
            "Sustainable performance",
          ],
          image: "/assets/img/recoonect_img_3.png",
          bgColor: "hsl(199deg 64% 73% / 31%)",
        },
      ],
    },
    section3: {
      heading:
        data?.section3?.heading ||
        "Reconnect → Align → Thrive is not linear — it’s a cycle.",
      body:
        data?.section3?.body ||
        "You reconnect to yourself, align your inner world, and naturally thrive in your work, relationships, and community.",
    },
    section4: {
      heading: data?.section4?.heading || "Guided Hire Details at a Glance",
      body:
        data?.section4?.body ||
        "Here’s everything you need to know and bring for the hire at le Pouce Mountain",
      subHeading1: data?.section4?.subHeading1 || "Walking Into Clarity",
      subHeading2: data?.section4?.subHeading2 || "The Last 20%",
      subHeading3: data?.section4?.subHeading3 || `“Lead Me, I’ll Trust You”`,
      subHeading4: data?.section4?.subHeading4 || "Lessons from the Mountain",
      subBody1:
        data?.section4?.subBody1 ||
        "Silent walk : personal reflection on career, business, or life. Paired “Clarity Walk”: What are you working towards in 2026?",
      subBody2:
        data?.section4?.subBody2 ||
        `Push past fatigue and resistance Reflect on perseverance in work and life Viewpoint pause: “If this is your future, what do you see?”`,
      subBody3:
        data?.section4?.subBody3 ||
        "Blind guidance exercise in pairs Learn to lead, listen, and let go Insights on trust, communication, and collaboration",
      subBody4:
        data?.section4?.subBody4 ||
        "One insight gained. One thing to release. One commitment moving forward. Shared words anchor the experience.",
    },
    section5: {
      heading: data?.section5?.heading || "Webinar Details at a Glance",
      body:
        data?.section5?.body ||
        "Here’s everything you need to know to show up and get the most out of the session.",
      amount: data?.section5?.amount || "Rs 2 500",
      reservation: data?.section5?.reservation || "By mail",
      WhatWillYouNeed:
        data?.section5?.WhatWillYouNeed ||
        " Water & snacks - energy bar, nuts... Hiking shoes or sturdy sneakers Lightweight jacket, hat & sunglasses First aid kit – basic items",
    },
    section6: {
      faqs: data?.section6?.faqs || [
        {
          question: "What are NuTerra’s core experiences?",
          answer:
            "Simply sign up for an account, create your profile highlighting your skills and experience, and start browsing or applying for projects that interest you.",
        },
        {
          question: "What can participants gain?",
          answer:
            "Simply sign up for an account, create your profile highlighting your skills and experience, and start browsing or applying for projects that interest you.",
        },
        {
          question: "Who can join NuTerra?",
          answer:
            "Simply sign up for an account, create your profile highlighting your skills and experience, and start browsing or applying for projects that interest you.",
        },
        {
          question: "How do I join a NuTerra experience?",
          answer:
            "Simply sign up for an account, create your profile highlighting your skills and experience, and start browsing or applying for projects that interest you.",
        },
        {
          question: "Do I need experience with mindfulness or hiking?",
          answer:
            "Simply sign up for an account, create your profile highlighting your skills and experience, and start browsing or applying for projects that interest you.",
        },
        {
          question: "Is NuTerra about performance or achievement?",
          answer:
            "Simply sign up for an account, create your profile highlighting your skills and experience, and start browsing or applying for projects that interest you.",
        },
      ],
    },
  });

  const getImageSrc = (image, fallback) => {
    if (!image) return fallback;

    if (typeof image === "string") return image;

    if (image instanceof File) {
      return URL.createObjectURL(image);
    }

    return fallback;
  };

  const handleHeaderFirstImage = (e) => {
    setHeaderFirstImage(e.target.files[0]);
  };

  const handleHeaderSecondImage = (e) => {
    setHeaderSecondImage(e.target.files[0]);
  };

  const handleCardImageChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    setCardImages((prev) => {
      const updated = [...prev];
      updated[index] = file;
      return updated;
    });
  };

  const handleChangeValue = (e, field, data) => {
    if (field == "section1" && data == "date") {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e,
        },
      }));
    } else if (field == "section1" && data == "time") {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e,
        },
      }));
    } else {
      setTemplateData((prev) => ({
        ...prev,
        [field]: {
          ...prev[field],
          [data]: e.target.innerText,
        },
      }));
    }
  };

  const handleCardChange = (e, cardIndex, key, benefitIndex = null) => {
    setTemplateData((prev) => ({
      ...prev,
      section2: {
        ...prev.section2,
        cards: prev.section2.cards.map((card, i) =>
          i === cardIndex
            ? {
              ...card,
              [key]:
                benefitIndex !== null
                  ? card[key].map((b, j) =>
                    j === benefitIndex ? e.target.innerText : b
                  )
                  : e.target.innerText,
            }
            : card
        ),
      },
    }));
  };

  const handleFaqChange = (index, field, value) => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: prevData.section6.faqs.map((faq, i) =>
          i === index ? { ...faq, [field]: value } : faq
        ),
      },
    }));
  };

  const handleAddFaq = () => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: [
          ...prevData.section6.faqs,
          { question: "Enter Question", answer: "Enter Answer" },
        ],
      },
    }));
  };

  const handleDeleteFaq = (index) => {
    setTemplateData((prevData) => ({
      ...prevData,
      section6: {
        ...prevData.section6,
        faqs: prevData.section6.faqs.filter((_, i) => i !== index),
      },
    }));
  };

  const validateTemplateData = (
    data,
    headerFirstImage,
    headerSecondImage,
    cardImages
  ) => {
    // SECTION 1
    if (
      !data.section1.heading ||
      !data.section1.subHeading ||
      !data.section1.body ||
      !data.section1.location ||
      !data.section1.duration ||
      !data.section1.language ||
      !data.section1.date ||
      !data.section1.time
    ) {
      return "Please complete all required fields in Section 1.";
    }

    // HEADER IMAGES
    if (!headerFirstImage) {
      return "Please upload the first header image.";
    }
    if (!headerSecondImage) {
      return "Please upload the second header image.";
    }

    // SECTION 2
    if (
      !data.section2.heading ||
      !data.section2.subHeading ||
      !data.section2.cards?.length
    ) {
      return "Please complete Section 2 details.";
    }

    // CARD CONTENT + IMAGES
    for (let i = 0; i < data.section2.cards.length; i++) {
      const card = data.section2.cards[i];

      if (
        !card.titleSmall ||
        !card.titleMain ||
        !card.description ||
        !card.benefits?.length
      ) {
        return `Please complete all fields in card ${i + 1}.`;
      }

      if (!cardImages[i]) {
        return `Please upload an image for card ${i + 1}.`;
      }
    }

    // SECTION 3
    if (!data.section3.heading || !data.section3.body) {
      return "Please complete Section 3.";
    }

    // SECTION 4
    if (
      !data.section4.heading ||
      !data.section4.body ||
      !data.section4.subBody1 ||
      !data.section4.subBody2
    ) {
      return "Please complete Section 4.";
    }

    // SECTION 5
    if (
      !data.section5.heading ||
      !data.section5.body ||
      !data.section5.amount
    ) {
      return "Please complete Section 5.";
    }

    return null; // ✅ ALL VALID
  };

  const handleSubmitNuTerra = () => {
    // 🔴 VALIDATION (TEXT + IMAGES)
    const error = validateTemplateData(
      templateData,
      headerFirstImage,
      headerSecondImage,
      cardImages
    );

    if (error) {
      toast.error(error);
      return;
    }
    if (pathname == adminPaths?.CreateNuterra) {
      return setIsSavedAsModal(true);
    }

    handleFinalSubmit();
  };

  const handleFinalSubmit = () => {
    const { date, time } = templateData.section1;

    // 🔁 LOCAL → UTC
    const { utcDate, utcTime } = localToUTCDateTimeParts(date, time);

    // ✅ section1 with UTC date & time
    const section1Payload = {
      ...templateData.section1,
      date: utcDate, // UTC DATE
      time: utcTime, // UTC TIME
    };

    const formData = new FormData();

    // 🔹 JSON SECTIONS
    formData.append("section1", JSON.stringify(section1Payload));
    formData.append("section2", JSON.stringify(templateData.section2));
    formData.append("section3", JSON.stringify(templateData.section3));
    formData.append("section4", JSON.stringify(templateData.section4));
    formData.append("section5", JSON.stringify(templateData.section5));
    formData.append("section6", JSON.stringify(templateData.section6));

    // 🔹 HEADER IMAGES
    formData.append("header_first_image", headerFirstImage);
    formData.append("header_second_image", headerSecondImage);

    formData.append("status", status);

    // 🔹 CARD IMAGES
    cardImages.forEach((img, index) => {
      formData.append(`card_image_${index + 1}`, img);
    });

    const callback = (res) => {
      if (res?.success) {
        navigate(-1);
      }
    };
    // 🔹 API CALL
    if (pathname == adminPaths?.CreateNuterra) {
      dispatch(
        createNuterraData({
          payload: formData,
          callback,
        })
      );
    } else if (pathname == adminPaths?.EditNuterraDetails) {
      dispatch(
        updateNuterraData({
          payload: formData,
          id: data?.nuterra_id,
          callback,
        })
      );
    }
  };

  const renderButton = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <button
              className="ct_yellow_btn ct_orange_btn"
              onClick={handleReserveYourSpot}
            >
              Join <span className="ct_fw_600 mx-1"> NuTerra </span> Hike
            </button>
          </>
        );
      case 1:
        return (
          <>
            <button
              className="ct_yellow_btn ct_sky_light_btn_new ct_darkblue_text"
              onClick={handleReserveYourSpot}
            >
              Align Your Practice{" "}
            </button>
          </>
        );
      case 2:
        return (
          <>
            <button className="ct_yellow_btn " onClick={handleReserveYourSpot}>
              Thrive With the Community{" "}
            </button>
          </>
        );

      default:
        break;
    }
  };

  return (
    <>
      {/* Section 1 */}
      <section class="ct_workshop_banner_detail ct_px_40 mt-5">
        <div class="container-fluid">
          <div class="row align-items-center ct_mb_100 pb-5">
            <div class="col-lg-7 mb-4 mb-lg-0">
              <div class="ps-lg-5">
                <h2
                  class="ct_fs_50 mb-0  ct_yellow_text ct_fw_700"
                  style={{ maxWidth: "596px" }}
                  contentEditable={contentEditable}
                  onBlur={(e) => handleChangeValue(e, "section1", "heading")}
                >
                  {templateData?.section1?.heading ?? ""}
                </h2>
                <h2
                  class="ct_fs_40 ct_mb_30 ct_first_line_color ct_orange_text"
                  contentEditable={contentEditable}
                  onBlur={(e) => handleChangeValue(e, "section1", "subHeading")}
                >
                  {templateData?.section1?.subHeading ?? ""}
                </h2>
                <p
                  class="ct_mb_30 ct_fs_20 ct_darkblue_text"
                  contentEditable={contentEditable}
                  onBlur={(e) => handleChangeValue(e, "section1", "body")}
                  style={{ maxWidth: "652px" }}
                >
                  {templateData?.section1?.body ?? ""}
                </p>

                <div class="ct_mt_30">
                  <a
                    class="ct_yellow_btn ct_orange_btn px-5 ct_fit_content"
                    onClick={handleReserveYourSpot}
                  >
                    View NuTerras
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-5 mb-4 mb-lg-0">
              <div className="position-relative ct_Authority_overlay_img_main">
                <label class="ct_workshop_right_img">
                  <input
                    className="d-none"
                    type={contentEditable ? "file" : "text"}
                    accept="image/*"
                    onChange={(e) => handleHeaderFirstImage(e)}
                  />
                  <img
                    // src={
                    //   headerFirstImage != ""
                    //     ? URL.createObjectURL(headerFirstImage) ??
                    //       "/assets/img/wellness_banner_img_1.png"
                    //     : "/assets/img/wellness_banner_img_1.png"
                    // }
                    src={getImageSrc(
                      headerFirstImage,
                      "/assets/img/wellness_banner_img_1.png",
                    )}
                    alt=""
                    className="ct_img_h_458"
                  />
                </label>
                <label class="ct_workshop_right_img">
                  <input
                    className="d-none"
                    type={contentEditable ? "file" : "text"}
                    accept="image/*"
                    onChange={(e) => handleHeaderSecondImage(e)}
                  />
                  <img
                    // src={
                    //   headerSecondImage != ""
                    //     ? URL.createObjectURL(headerSecondImage) ??
                    //       "/assets/img/wellness_banner_img_2.png"
                    //     : "/assets/img/wellness_banner_img_2.png"
                    // }
                    src={getImageSrc(
                      headerSecondImage,
                      "/assets/img/wellness_banner_img_2.png",
                    )}
                    alt=""
                    className="ct_img_h_328"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="d-lg-flex  align-items-center justify-content-around gap-3 mt-5 pb-3 ct_mt_3_1326 ct_grid_2_991_new">
            <label className="mb-0 d-flex align-items-center gap-1  ct_text_op_8 ct_fs_24 ct_outline_blue_5 ct_ms_minus_55">
              <input
                type="date"
                className="border-0 form-control px-0"
                min={new Date().toISOString().split("T")[0]}
                readOnly={!contentEditable}
                value={templateData?.section1?.date}
                onChange={(e) =>
                  handleChangeValue(e.target.value, "section1", "date")
                }
              />
              <input
                type="time"
                className="border-0 form-control"
                readOnly={!contentEditable}
                value={templateData?.section1?.time}
                onChange={(e) =>
                  handleChangeValue(e.target.value, "section1", "time")
                }
              />
            </label>
            <div
              class="ct_text_op_8 ct_fs_24  d-flex align-items-start gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
              contentEditable={contentEditable}
              onBlur={(e) => handleChangeValue(e, "section1", "location")}
            >
              <img
                src="/assets/img/location_icon_big_new.png"
                className="ct_icon_30"
              />{" "}
              {templateData?.section1?.location ?? ""}
            </div>
            <div
              class="ct_text_op_8 ct_fs_24  d-flex align-items-center gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
              contentEditable={contentEditable}
              onBlur={(e) => handleChangeValue(e, "section1", "language")}
            >
              <img src="/assets/img/globe_icon.png" className="ct_icon_30" />{" "}
              {templateData?.section1?.language ?? ""}
            </div>
            <div
              class="ct_text_op_8 ct_fs_24   d-flex align-items-center gap-4 ct_para_scroll ct_custom_scroll"
              style={{ maxWidth: "250px", maxHeight: "50px" }}
              contentEditable={contentEditable}
              suppressContentEditableWarning
              onBlur={(e) => handleChangeValue(e, "section1", "duration")}
            >
              <img
                src="/assets/img/clock_new_icxon_22.png"
                className="ct_icon_30"
              />
              {templateData?.section1?.duration ?? ""}{" "}
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 */}
      <section className="pt-5 ct_px_40">
        <div className="container-fluid">
          <div className="row ct_mb_90">
            <div className="col-md-12">
              <h4
                className="ct_fs_36 ct_darksky_blue_text text-center"
                contentEditable={contentEditable}
                onBlur={(e) => handleChangeValue(e, "section2", "heading")}
              >
                {templateData?.section2?.heading ?? ""}
              </h4>
              <h2
                className="ct_fs_48 ct_fw_700 ct_yellow_text text-center mb-0"
                contentEditable={contentEditable}
                onBlur={(e) => handleChangeValue(e, "section2", "subHeading")}
              >
                {templateData?.section2?.subHeading ?? ""}
              </h2>
            </div>
          </div>

          <div className="row gx-md-5">
            {templateData?.section2?.cards?.map((card, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-5">
                <div
                  className="ct_reconnect_card"
                  style={{ backgroundColor: card.bgColor }}
                >
                  <div className="ct_px_28">
                    <div className="text-center ct_mb_20">
                      <h4
                        className="ct_fs_36 ct_darksky_blue_text mb-0"
                        contentEditable={contentEditable}
                        onBlur={(e) => handleCardChange(e, index, "titleSmall")}
                      >
                        {card.titleSmall}
                      </h4>

                      <h2
                        className="ct_fs_48 ct_orange_text ct_fw_700 mb-0"
                        contentEditable={contentEditable}
                        onBlur={(e) => handleCardChange(e, index, "titleMain")}
                      >
                        {card.titleMain}
                      </h2>
                    </div>

                    <p
                      className="ct_fs_18 ct_darkblue_text text-center ct_mb_20"
                      contentEditable={contentEditable}
                      onBlur={(e) => handleCardChange(e, index, "shortDesc")}
                    >
                      {card.shortDesc}
                    </p>

                    <h4
                      className="ct_fs_24_new ct_fw_700 ct_darkblue_text text-center mx-auto"
                      contentEditable={contentEditable}
                      onBlur={(e) => handleCardChange(e, index, "tagline")}
                    >
                      {card.tagline}
                    </h4>

                    <div className="ct_mt_20">
                      <p
                        className="ct_darkblue_text mb-2"
                        contentEditable={contentEditable}
                        onBlur={(e) =>
                          handleCardChange(e, index, "description")
                        }
                      >
                        {card.description}
                      </p>

                      <h6 className="ct_fw_700 ct_darkblue_text mb-2">
                        What you gain:
                      </h6>

                      <ul className="ps-4" style={{ listStyle: "disc" }}>
                        {card.benefits.map((benefit, bIndex) => (
                          <li
                            key={bIndex}
                            contentEditable={contentEditable}
                            onBlur={(e) =>
                              handleCardChange(e, index, "benefits", bIndex)
                            }
                          >
                            {benefit}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="ct_reconnect_card_img">
                    {/* <img src={card.image} alt="" /> */}
                    <label className="ct_workshop_right_img d-block">
                      <input
                        type={contentEditable ? "file" : "text"}
                        className="d-none"
                        accept="image/*"
                        onChange={(e) => handleCardImageChange(e, index)}
                      />

                      <img
                        // src={
                        //   cardImages[index]
                        //     ? URL.createObjectURL(cardImages[index])
                        //     : card.image // fallback from templateData
                        // }
                        src={getImageSrc(cardImages[index], card.image)}
                        alt=""
                        style={{ maxWidth: "100%" }}
                      />
                    </label>
                    {renderButton(index)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3 */}
      <section className="ct_px_40 ct_mt_90">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="ct_recycle_img">
                <img src="/assets/img/cycle_img.png" />
              </div>
            </div>
            <div className="col-md-8 mb-4 mb-md-0">
              <div className="text-center">
                <h3
                  className="ct_fs_35 ct_mb_20 ct_orange_text "
                  contentEditable={contentEditable}
                  onBlur={(e) => handleChangeValue(e, "section3", "heading")}
                >
                  {templateData?.section3?.heading ?? ""}
                </h3>
                <p
                  className="ct_fs_24 mb-0 mx-auto"
                  style={{ maxWidth: "631px" }}
                  contentEditable={contentEditable}
                  onBlur={(e) => handleChangeValue(e, "section3", "body")}
                >
                  {templateData?.section3?.body ?? ""}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg ct_mt_100  ct_p_111_y_106 ct_looking_for_work_bg_left"
        style={{ backgroundColor: "#8ECAE6" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4 ct_darkblue_text">
              Start your growth journey today with us.
            </h4>
            <p class="mb-0 ct_fs_18">
              Shaped by your feedback, our platform evolves with you — every
              step of the way.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_orange_btn ct_darkblue_text ct_flex_1 px-5"
              onClick={() => {
                if (pathname == coachPaths.NuvioWellness) {
                  openSignUp();
                  // navigate(coachPaths.BecomeCoach);
                }
              }}
            >
              Start Now
            </a>
          </div>
        </div>
      </section>

      {/* Section 4 */}
      <section class="ct_py_100 ct_px_100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h2
                class="ct_fs_40 ct_fw_700 ct_orange_text text-center mb-3 ct_fw_600"
                contentEditable={contentEditable}
                onBlur={(e) => handleChangeValue(e, "section4", "heading")}
              >
                {templateData?.section4?.heading ?? ""}
              </h2>
              <p
                class="mb-0 ct_fs_24 text-center mx-auto"
                style={{ maxWidth: "961px" }}
                contentEditable={contentEditable}
                onBlur={(e) => handleChangeValue(e, "section4", "body")}
              >
                {templateData?.section4?.body ?? ""}
              </p>
            </div>
          </div>
          <div class="row mt-5 pt-3 gx-lg-5">
            <div class="col-lg-4 mb-4 mb-lg-0 h-100">
              <div
                class="ct_what_learn_card mb-4 h-100"
                style={{ backgroundColor: "hsl(43deg 100% 51% / 20%)" }}
              >
                <div>
                  <h4
                    class="ct_fs_24_new mb-2"
                    contentEditable={contentEditable}
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading1")
                    }
                  >
                    {templateData?.section4?.subHeading1 ?? ""}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "120px" }}
                    contentEditable={contentEditable}
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody1")}
                  >
                    {templateData?.section4?.subBody1}
                  </p>
                </div>
                <div class="mt-2  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon ct_arrow_postion_right_btm">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4 h-100"
                style={{ backgroundColor: "hsl(199deg 64% 73% / 20%)" }}
              >
                <div>
                  <h4
                    class="ct_fs_24_new mb-2"
                    contentEditable={contentEditable}
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading2")
                    }
                  >
                    {templateData?.section4?.subHeading2 ?? ""}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "120px" }}
                    contentEditable={contentEditable}
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody2")}
                  >
                    {templateData?.section4?.subBody2}
                  </p>
                </div>
                <div class="mt-2  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon ct_arrow_postion_right_btm">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0 h-100">
              <label class="ct_learn_img">
                <img
                  src="/assets/img/humun_image_center.png"
                  alt=""
                  style={{ height: "420px" }}
                />
              </label>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0 h-100">
              <div
                class="ct_what_learn_card mb-4 h-100"
                style={{ backgroundColor: "hsl(192deg 70% 43% / 20%)" }}
              >
                <div>
                  <h4
                    class="ct_fs_24_new mb-2"
                    contentEditable={contentEditable}
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading3")
                    }
                  >
                    {templateData?.section4?.subHeading3 ?? ""}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "120px" }}
                    contentEditable={contentEditable}
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody3")}
                  >
                    {templateData?.section4?.subBody3}
                  </p>
                </div>
                <div class="mt-2  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon ct_arrow_postion_right_btm">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
              <div
                class="ct_what_learn_card mb-4 h-100"
                style={{ backgroundColor: "hsl(32deg 100% 49% / 20%)" }}
              >
                <div>
                  <h4
                    class="ct_fs_24_new mb-2"
                    contentEditable={contentEditable}
                    onBlur={(e) =>
                      handleChangeValue(e, "section4", "subHeading4")
                    }
                  >
                    {templateData?.section4?.subHeading4 ?? ""}
                  </h4>
                  <p
                    class="mb-0 ct_grey_text ct_para_scroll ct_custom_scroll"
                    style={{ maxHeight: "120px" }}
                    contentEditable={contentEditable}
                    onBlur={(e) => handleChangeValue(e, "section4", "subBody4")}
                  >
                    {templateData?.section4?.subBody4}
                  </p>
                </div>
                <div class="mt-2  d-flex justify-content-end">
                  <a class="ct_top_right_arrow_icon ct_arrow_postion_right_btm">
                    <img src="/assets/img/right_top_arrow.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 5 */}
      <section
        class="ct_py_90 ct_light_sky_bg "
        style={{ backgroundColor: "hsl(43deg 100% 51% / 21%)" }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <h2
                class="ct_fs_40 mb-2 ct_fw_600 text-center ct_darksky_blue_text "
                contentEditable={contentEditable}
                onBlur={(e) => handleChangeValue(e, "section5", "heading")}
              >
                {templateData?.section5?.heading ?? ""}
              </h2>
              <p
                class="mb-0  text-center ct_fs_24_new"
                contentEditable={contentEditable}
                onBlur={(e) => handleChangeValue(e, "section5", "body")}
              >
                {templateData?.section5?.body ?? ""}
              </p>
            </div>
          </div>
          <div class="row ct_pt_60">
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/line-md_calendar.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Date & Time
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Date: </span>
                      <label>
                        <input
                          type="date"
                          className="border-0 form-control"
                          min={new Date().toISOString().split("T")[0]}
                          value={templateData?.section1?.date}
                          readOnly={!contentEditable}
                          onChange={(e) =>
                            handleChangeValue(
                              e.target.value,
                              "section1",
                              "date",
                            )
                          }
                        />
                      </label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Time: </span>
                      <label>
                        <input
                          type="time"
                          className="border-0 form-control"
                          value={templateData?.section1?.time}
                          readOnly={!contentEditable}
                          onChange={(e) =>
                            handleChangeValue(
                              e.target.value,
                              "section1",
                              "time",
                            )
                          }
                        />
                      </label>
                    </p>
                    <p className="ct_fs_18 ct_line_h_30  mb-0">
                      <span className="ct_white_nowrap">Duration: </span>
                      <span
                        contentEditable={contentEditable}
                        suppressContentEditableWarning
                        onBlur={(e) =>
                          handleChangeValue(e, "section1", "duration")
                        }
                      >
                        {templateData?.section1?.duration ?? ""}{" "}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/locationLogo.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      Location
                    </h4>
                    <p className="ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap ct_fw_600">Place: </span>
                      <span
                        contentEditable={contentEditable}
                        onBlur={(e) =>
                          handleChangeValue(e, "section1", "location")
                        }
                      >
                        {" "}
                        {templateData?.section1?.location ?? ""}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap ct_fw_600">
                        Amount:{" "}
                      </span>{" "}
                      <span
                        contentEditable={contentEditable}
                        onBlur={(e) =>
                          handleChangeValue(e, "section5", "amount")
                        }
                      >
                        {" "}
                        {templateData?.section5?.amount ?? ""}
                      </span>
                    </p>
                    <p className=" ct_fs_18 ct_line_h_30   mb-0">
                      <span className="ct_white_nowrap ct_fw_600">
                        Reservation:{" "}
                      </span>
                      <span
                        contentEditable={contentEditable}
                        onBlur={(e) =>
                          handleChangeValue(e, "section5", "reservation")
                        }
                      >
                        {" "}
                        {templateData?.section5?.reservation ?? ""}
                      </span>
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 mb-4 mb-md-0">
              <div class="ct_glance_card text-center">
                <figure class="mb-0">
                  <div class="ct_glance_icon mb-3">
                    <img
                      src="/assets/img/file.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                  </div>
                  <figcaption class="text-center">
                    <h4 class="ct_fs_24 mb-3 ct_darksky_blue_text ct_fw_600">
                      What You’ll Need
                    </h4>
                    <p
                      class="mb-0 ct_fs_18 text-center mx-auto ct_line_h_30"
                      contentEditable={contentEditable}
                      onBlur={(e) =>
                        handleChangeValue(e, "section5", "WhatWillYouNeed")
                      }
                    >
                      {" "}
                      {templateData?.section5?.WhatWillYouNeed ?? ""}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div class="text-center ct_mt_40">
            <button
              class="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
              onClick={handleReserveYourSpot}
            >
              Reserve Your Spot
            </button>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 pt-0 ct_mt_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-7 col-xl-6 col-md-6 mb-4 mb-md-0">
              <div class="ct_about_cnt">
                <h2 class="mb-4 ct_fs_32 mb-5 ">Frequently asked questions</h2>
                <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                  <div class="accordion" id="faq_accordionExample">
                    {templateData?.section6?.faqs?.map((item, i) => (
                      <div className="d-flex align-items-center gap-2">
                        <div class="accordion-item ct_flex_1">
                          <h2 class="accordion-header" id={`faq_${i}`}>
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapsefaq_one${i}`}
                              aria-expanded="false"
                              aria-controls={`collapsefaq_one${i}`}
                            >
                              <span
                                contentEditable={contentEditable}
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                  handleFaqChange(
                                    i,
                                    "question",
                                    e.target.innerText.trim() ||
                                      "Enter Question",
                                  )
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.target.blur();
                                  }
                                }}
                                style={{ outline: "none", width: "100%" }}
                              >
                                {item?.question || "Enter Question"}
                              </span>
                            </button>
                          </h2>
                          <div
                            id={`collapsefaq_one${i}`}
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p
                                class="ct_fs_20 mb-3 ct_line_h_30"
                                contentEditable={contentEditable}
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                  handleFaqChange(
                                    i,
                                    "answer",
                                    e.target.innerText.trim(),
                                  )
                                }
                              >
                                {item?.answer != ""
                                  ? item?.answer
                                  : "Enter Answer"}
                              </p>
                            </div>
                          </div>
                        </div>
                        {templateData?.section6?.faqs?.length > 1 &&
                          contentEditable && (
                            <div className="mt-3 ct_cursor_pointer">
                              <i
                                class="fa-solid fa-trash-can text-danger"
                                onClick={() => handleDeleteFaq(i)}
                              ></i>
                            </div>
                          )}
                      </div>
                    ))}
                    {contentEditable && (
                      <div className="text-end mt-3">
                        <a
                          className="ct_orange_text ct_fw_600"
                          onClick={handleAddFaq}
                        >
                          + Add FAQ
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-4  col-xl-6 col-md-6 mb-4 mb-md-0 ps-md-5">
              <label class="ct_about_img">
                <img
                  src="/assets/img/wellness_img_right.png"
                  class="ct_img_h_617"
                  alt=""
                />
              </label>
            </div>
          </div>
        </div>
      </section>

      <section
        class="ct_looking_for_work_bg ct_mt_100 ct_mb_100 ct_p_111_y_106"
        style={{ backgroundColor: "#FFB703" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4" style={{ maxWidth: "640px" }}>
              Ready to Take the Next Step?
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "607px" }}>
              Whether you’re launching something new or levelling up your
              strategy, let’s make it happen together.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              Book a Coaching Session
            </a>
          </div>
        </div>
      </section>

      {pathname == adminPaths?.CreateNuterra && isSavedAsModal && (
        <SavedAs
          setIsModal={setIsSavedAsModal}
          status={status}
          setSatus={setSatus}
          onSubmit={handleFinalSubmit}
        />
      )}

      {pathname == adminPaths?.CreateNuterra && (
        <div className="text-center mb-5">
          <button
            className="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
            type="button"
            onClick={handleSubmitNuTerra}
          >
            Submit
          </button>
        </div>
      )}
      {pathname == adminPaths?.EditNuterraDetails && (
        <div className="text-center mb-5">
          <button
            className="ct_yellow_btn ct_sky_blue_btn px-5 mx-auto"
            type="button"
            onClick={handleSubmitNuTerra}
          >
            Update
          </button>
        </div>
      )}

      {pathname == coachPaths?.NuvioWellness && isModal && (
        <ReserveYourSpot data={data} setIsModal={setIsModal} page={"nuterra"} />
      )}
    </>
  );
};

export default Wellness;
